// "use strict";
//扩展静态化逻辑
(function (smarket) {
    var template = smarket.template = smarket.template || {},
        service = smarket.api.template;
    smarket.api.s5g = function(url, data, success, type) {
        var defer = $.Deferred();
        // 存在静态化配置，优先获取静态连接，如不存在，走API请求
        var staticUrl = window.staticReqMapping ? window.staticReqMapping.getStaticUrl(url, data) : '';
        // console.log('########################################');
        // console.log(url, staticUrl);
        // console.log('########################################');
        if (staticUrl) {
            // 请求静态地址(url上需要添加随机数，以保证数据为最新)
            $.getJSON(staticUrl + '?time_stamp=' + new Date().getTime()).then(function (res) {
                // console.log('getJSON res', res);
                if (res && res.body) {
                    if (res.body.hasOwnProperty('result') && parseInt(res.body.result) === 0) {
                        return defer.resolve(res.body);
                    }
                    defer.reject(res.body);
                } else {
                    defer.reject(res.body);
                }
            }, function (xhr) { // 静态化请求出错，转为API请求
                console.log('静态地址 ' + staticUrl + ' 出错，状态码 - ' + xhr.status);
                console.log('======> 转为api请求');
                return smarket.api.s3g(url, data, success, type).then(function (res) {
                    return defer.resolve(res);
                },function (res) {
                    defer.reject(res);
                });
            });
        }
        else {
            return smarket.api.s3g(url, data, success, type).then(function (res) {
                return defer.resolve(res);
            },function (res) {
                defer.reject(res);
            });
        }
        return defer.promise();
    };
    service.getConfig=function (configId,tenantId) {
        return smarket.api.s5g('/template/template/getConfig', { configId: configId,tenantId:tenantId });
    }
//根据configId渲染页面
    template.renderByConfigId = function(name, configId,tenantId) {
        configId = configId || smarket.urlParams.configId;
        tenantId=tenantId||smarket.Config('tenantId');
        if (!configId) {
            return $.Deferred(function(defer) {
                console.log('Param "configId" is not undefined');
                defer.resolve();
            }).promise();
        }
        return service.getConfig(configId,tenantId).then(function(data) {
            var content = data.content;
            if (content && 'configInfo' in content) {
                return template.renderByConfig(name, content.configInfo);
            }
        });
    };
})(smarket);